export const defaultQueryParamsAllowList = [
    // Core Analytics & Attribution
    'utm_campaign',
    'utm_content',
    'utm_device',
    'utm_id',
    'utm_matchtype',
    'utm_medium',
    'utm_placement',
    'utm_source',
    'utm_term',
    // Ad Platform Click IDs
    'fbclid',
    'gad_campaignid',
    'gad_source',
    'gbraid',
    'gclid',
    'msclkid',
    // Top used query params from Hubble
    'account',
    'action',
    'active',
    'amount',
    'api_version',
    'attemptId',
    'autorun',
    'backTo',
    'campaign',
    'channel',
    'code_challenge_method',
    'code_challenge',
    'compare_to_end',
    'compare_to_filter',
    'compare_to_start',
    'connected_accounts',
    'contact',
    'copy_to_live',
    'country',
    'create',
    'created',
    'currency',
    'cursor',
    'customer',
    'dataset_id',
    'date',
    'destination',
    'device_type',
    'dispute',
    'edit',
    'email_id',
    'enabled',
    'endDate',
    'ending_before_ts',
    'ending_before',
    'endpoint_location',
    'eventId',
    'eventType',
    'experiment_id',
    'experiment',
    'feature',
    'filtered',
    'flow',
    'force_login',
    'from',
    'fromWizard',
    'id',
    'iframe',
    'in_flow',
    'invoice',
    'lang',
    'language',
    'lid',
    'limit',
    'linkType',
    'livemode',
    'locale',
    'medium',
    'merchant_name',
    'mode',
    'object',
    'offset',
    'order',
    'org_name',
    'page_number',
    'page',
    'past_due',
    'payment_intent',
    'payments',
    'payout_option',
    'platform',
    'portalFlowType',
    'previous',
    'price',
    'primary_filter',
    'quantity',
    'rate',
    'read_filter',
    'redirect_uri',
    'redirect',
    'ref',
    'referer',
    'remediate',
    'response_type',
    'returnToSearch',
    'review',
    'ruleId',
    'schedule_phase_index',
    'scope',
    'search_context_id',
    'section',
    'selected_tab',
    'selected',
    'session_type',
    'settingsRedirect',
    'sort_direction',
    'sort_field',
    'sort',
    'source',
    'startDate',
    'starting_after_ts',
    'starting_after',
    'state',
    'status',
    'step',
    'stripe_landing',
    'subscription_default_customer',
    'subscription',
    'switch',
    'tab',
    'teams',
    'templateType',
    'test',
    'ticket_id',
    'timezone',
    'treatment',
    'type',
    'ui',
    'unit',
    'variant',
    'version',
    'view_id',
    'view_type',
    'view',
    'visitor_type',
    'year'
];

//# sourceMappingURL=defaultQueryParamsAllowList.js.map